import { render, staticRenderFns } from "./StaffGrid4PeopleItem.vue?vue&type=template&id=81e3f046&scoped=true"
import script from "./StaffGrid4PeopleItem.vue?vue&type=script&lang=js"
export * from "./StaffGrid4PeopleItem.vue?vue&type=script&lang=js"
import style0 from "./StaffGrid4PeopleItem.vue?vue&type=style&index=0&id=81e3f046&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e3f046",
  null
  
)

export default component.exports